export default __webpack_public_path__ + "static/media/hero-thumb-9.c3932caa.png";